import { makeObservable, observable, computed, action } from 'mobx';
import { erpApiurl } from '../stores/APIEndpoints';

const PENDING = 'pending';
const DONE = 'done';
const ERROR = 'error';

const EMPTY_MESSAGE = { status: "", help: "" };
const ERROR_MESSAGE = { status: "error", help: "Unable to fetch the Payables. The Service is unavailable. Please try after sometime." };

export default class DenominationStore {

    branchState = PENDING;
    state = PENDING;
    message = EMPTY_MESSAGE;

    errorReffererIds = new Set();

    denominations= [];
    isDrawerOpened = false
    denominationNotes = [];
    paymentData = [];
    totalAmount = 0;
    totalCharges = 0;
    denominationId = 0;
    paymentType = "Cash";
    startDate = "";
    endDate = "";
    branchId = 0;
    branchList = [ {
        value: 0, label: 'All Branch'
    }];

    branchId = 0;
    rowCount = 0;
    totalAmountSum = 0;

    constructor(props) {
        this.apiProxy = props.apiProxy;

        makeObservable(this, {
            state: observable,
            message: observable,
            
            rowCount: observable,
            denominationId: observable,
            totalAmountSum: observable,
            startDate: observable,
            endDate: observable,
            branchId: observable,
            branchList:observable,
            totalCharges: observable,
            paymentType: observable,
            paymentData:observable,
            
            branchId: observable,
            errorReffererIds: observable,
            denominations: observable,
            isDrawerOpened: observable,
            denominationNotes: observable,
            totalAmount: observable,

            isLoading: computed,
            isError: computed,
            isDone: computed,

            fetchCashDenominations: action,

        });
    }


    get isLoading() {
        return this.state === PENDING;
    }

    get isError() {
        return this.state === ERROR;
    }

    get isDone() {
        return this.state === DONE;
    }   

    get isBranchDone() {
        return this.branchState === DONE;
    }   

    GetallBranchName = async() => {
  
        const payload = {
            BranchId:0,
        }

        this.branchState = PENDING;

        const reportUrl = `${erpApiurl}/api/carbon/LTBranchDetails`;
        const response = await this.apiProxy.asyncPost(reportUrl,payload);
        const branches = await response.json();

        this.branchState = DONE;

        branches.map((branch) => {
            const branchVal = {
                value: branch.BranchId,
                label: branch.BranchName
            }   

            this.branchList.push(branchVal)
            }
        );

    }   

    GetPaymentData = async() => {

        const reportUrl = `${erpApiurl}api/cashDenomination/GetCardHistory?CashLogsId=` + this.denominationId;

        try {
            const response = await this.apiProxy.getAsync(reportUrl);
            const result = await response.json();

            this.paymentData = result;

            this.totalAmount = result.map(item => parseFloat(item.Amount)).reduce((a, b) => a + b, 0);
            this.totalCharges = result.map(item => parseFloat(item.Charges)).reduce((a, b) => a + b, 0);

            console.log(result);
        }
        catch (e) {
            console.log(e);
        }

    }   
 
   
    /**
     * Send the request to the endpoint using the FetchAPI
     * 
     */
    fetchCashDenominations = async () => {

        const payload = {
            fdate: this.startDate,
            tdate: this.endDate,
            BranchId: this.branchId
        }

        const url = `${erpApiurl}api/CashDenomination/CashDenominationMddashboard`;
        this.state = PENDING;
        this.message = EMPTY_MESSAGE;

        try {
            const response = await this.apiProxy.asyncPost(url,payload);
            const result = await response.json();

            if (result.Message) {
                this.message = ERROR_MESSAGE;
                this.state = DONE;
                return;
            }

            this.denominations = result;

            this.totalAmountSum = result.map(item => item.TotalAmount).reduce((a, b) => a + b, 0);

            this.rowCount = result.length;
           
            this.state = DONE;
        }
        catch (e) {
            this.state = ERROR;
            this.message = ERROR_MESSAGE
            console.log(e);
        }
    }

    approve = async (ids) => {

        const payload = {
            ids: ids
        }

        const url = `${erpApiurl}api/CashDenomination/OnApprove`;
        this.state = PENDING;
        this.message = EMPTY_MESSAGE;

        try {
            const response = await this.apiProxy.asyncPost(url,payload);
            const result = await response.json();

            if (result.Message) {
                this.message = ERROR_MESSAGE;
                this.state = DONE;
                return;
            }
           
            this.state = DONE;
        }
        catch (e) {
            this.state = ERROR;
            this.message = ERROR_MESSAGE
            console.log(e);
        }
    }


}
